class FacebookMessanger {
    constructor(node) {
        this.node = node;
    }
    init() {
        setTimeout(() => {
            window.fbAsyncInit = function() {
                FB.init({
                    xfbml            : true,
                    version          : 'v17.0'
                });
            };
        
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = 'https://connect.facebook.net/pl_PL/sdk/xfbml.customerchat.js';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

        }, document.querySelector('.FacebookMessanger').getAttribute('data-timeout') );
    }
}
JSModules['FacebookMessanger'] = FacebookMessanger;
export default FacebookMessanger;